export const LxgW = {
    base: {
        code: "lxgW",
        name: "凌雪阁悟"
    },
    methodAttribute: {
        atPhysicsAttackPowerBase: 6904,
        atPhysicsOvercomeBase: 6389,
    },
    coefficient: {
        // 转化系数属性
        agilityToPhysicsAttackPowerCof: 1772,
        agilityToPhysicsOvercomeCof: 553,
    },
    // 装备类型
    equipment: {
    },
    recipe: {
        recipeList: [
            {
                code: '',
                name: "",
                recipeOptional: [
                ],
                selected: [],
            },
        ]
    },
    loop: {
        // 装备→循环映射
        equipLoopMap: new Map([
            // [35623, "wuCWLoop"],
            // [36564, "wuCWLoop"],
            // [36594, "wuCWLoop"],
            // [38041, "wuCWLoop"],
            // [38072, "wuCWLoop"],
            // [38582, "wuCWLoop"],
            // [40187, "wuCWLoop"],
            // [40219, "wuCWLoop"],
            // [40251, "wuCWLoop"],
            // [40283, "wuCWLoop"],
            // [40315, "wuCWLoop"],
        ]
        )
    },
    allBuff: {
        income: {
            drug: {
                zqxy: "29289-1",
                zqxc: "29276-1",
                fzxy: "29288-2",
                fzxc: "29274-2",
                wqms: "15778",
                jyxc: "17365-60",
                jyxj: "17361-2",
                tdyx: ["10100-2", "18428-1", "29284-1"]
            },
            equipment: {
                suit: ["5037", "5038", "1927"],
                weapon: "yuanWangHou",
                cutCake: "null",
                pendant: "lianTianJi"
            },
            position: "lingXueZiJiZhen"

        },
    }
}